import { ButtonHTMLAttributes, FC } from 'react';

import classes from './secondaryButton.module.css';

type SecondaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
};

export const SecondaryButton: FC<SecondaryButtonProps> = ({ children, className, ...rest }) => {
  return (
    <button className={`${classes.secondaryButton} ${className || ''}`} {...rest}>
      {children}
    </button>
  );
};
